import { gql } from '@apollo/client';

/**
 * Create a person from the new registration form.
 *
 * This is the **same** `adminCreateUser` the classic form calls — every registration argument
 * is optional server-side, and the classic form simply sends none of them. One mutation rather
 * than two is what keeps the toggle honest: there is no second code path to drift.
 */
export const CREATE_PERSON_WITH_REGISTRATION = gql`
mutation AdminCreateUserWithRegistration(
  $name: String!
  $preferredName: String
  $picturePermission: Boolean!
  $address: String
  $scriptName: String
  $identifier: String
  $tagIds: [Int!]
  $gender: String
  $phone: String
  $dob: String
  $registrationCompleted: Boolean
  $consentDataCollection: Boolean
  $healthSafetyBriefed: Boolean
  $consentHealthSafety: Boolean
  $idSightedByCM: Boolean
  $guardianName: String
  $guardianDob: String
  $guardianRelationship: String
  $guardianIsMinorNoAlternative: Boolean
  $guardianConsentsToChildData: Boolean
  $guardianIdSightedConfirmsRelationship: Boolean
  $guardianNoIdButConfirmed: Boolean
) {
  adminCreateUser(
    name: $name
    preferredName: $preferredName
    picturePermission: $picturePermission
    address: $address
    scriptName: $scriptName
    identifier: $identifier
    tagIds: $tagIds
    gender: $gender
    phone: $phone
    dob: $dob
    registrationCompleted: $registrationCompleted
    consentDataCollection: $consentDataCollection
    healthSafetyBriefed: $healthSafetyBriefed
    consentHealthSafety: $consentHealthSafety
    idSightedByCM: $idSightedByCM
    guardianName: $guardianName
    guardianDob: $guardianDob
    guardianRelationship: $guardianRelationship
    guardianIsMinorNoAlternative: $guardianIsMinorNoAlternative
    guardianConsentsToChildData: $guardianConsentsToChildData
    guardianIdSightedConfirmsRelationship: $guardianIdSightedConfirmsRelationship
    guardianNoIdButConfirmed: $guardianNoIdButConfirmed
  ) {
    id
  }
}`;

/** Record (or revise) consent for someone who already exists — the profile editor's path. */
export const SET_PERSON_REGISTRATION = gql`
mutation SetPersonRegistration(
  $personId: Int!
  $registrationCompleted: Boolean
  $consentDataCollection: Boolean
  $healthSafetyBriefed: Boolean
  $consentHealthSafety: Boolean
  $idSightedByCM: Boolean
  $guardianName: String
  $guardianDob: String
  $guardianRelationship: String
  $guardianIsMinorNoAlternative: Boolean
  $guardianConsentsToChildData: Boolean
  $guardianIdSightedConfirmsRelationship: Boolean
  $guardianNoIdButConfirmed: Boolean
) {
  setPersonRegistration(
    personId: $personId
    registrationCompleted: $registrationCompleted
    consentDataCollection: $consentDataCollection
    healthSafetyBriefed: $healthSafetyBriefed
    consentHealthSafety: $consentHealthSafety
    idSightedByCM: $idSightedByCM
    guardianName: $guardianName
    guardianDob: $guardianDob
    guardianRelationship: $guardianRelationship
    guardianIsMinorNoAlternative: $guardianIsMinorNoAlternative
    guardianConsentsToChildData: $guardianConsentsToChildData
    guardianIdSightedConfirmsRelationship: $guardianIdSightedConfirmsRelationship
    guardianNoIdButConfirmed: $guardianNoIdButConfirmed
  ) {
    id
    completedAt
  }
}`;

export const CREATE_PERSON_DOCUMENT_UPLOAD = gql`
mutation CreatePersonDocumentUpload($personId: Int!, $kind: String!, $fileName: String!, $contentType: String!) {
  createPersonDocumentUpload(personId: $personId, kind: $kind, fileName: $fileName, contentType: $contentType) {
    uploadUrl
    document {
      id
      kind
      fileName
    }
  }
}`;

export const ARCHIVE_PERSON_DOCUMENT = gql`
mutation ArchivePersonDocument($documentId: Int!) {
  archivePersonDocument(documentId: $documentId) {
    id
  }
}`;
